import { createFileRoute, redirect } from '@tanstack/react-router'
import { PrepaidSchedulesScreen } from '@/features/accounting-close/prepaid-schedules-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/prepaid')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_spend.view')) throw redirect({ to: '/' })
  },
  component: PrepaidSchedulesScreen,
})
